import React from "react";
import PageLoader from "../components/PageLoader/PageLoader";

import HeaderOne from "../components/Header/HeaderOne";
import FooterOne from "../components/Footer/FooterOne";
import BlogBreadcrumb from "../components/BlogBreadcrumb/BlogBreadcrumb";

const LayoutTwo = (props) => {
  return (
    <div>
      <PageLoader />

      <HeaderOne />

      <main>
        <section className="blog-area">
          <div className="container">
            <div className="col-lg-12">{props.children}</div>

            {/* <div className="col-lg-4">
                <BlogAside />
              </div> */}
          </div>
        </section>
      </main>

      <FooterOne />
    </div>
  );
};

export default LayoutTwo;
